import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

/**
 * Confirmation modal shown once per (session, memberId) before a spoofed
 * staff session sends a message into an existing customer-visible Trip
 * Planner chat. Fails closed: cancelling or dismissing the modal resolves
 * false, aborting the send.
 */
function ConfirmSpoofSendModal() {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const handleCancel = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const handleConfirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  return (
    <Modal
      title={intl.formatMessage({
        id: 'h5nBjQ6-N_s3SHs-7H61',
        defaultMessage: 'The customer will see this message',
        description: 'Modal title warning a spoofed staff session that the customer will see the message they are about to send into an existing visible Trip Planner chat',
      })}
      primaryActionText={intl.formatMessage({
        id: 'IUUK_wEKAogjr6X6t3lu',
        defaultMessage: 'Send anyway',
        description: 'Primary action button confirming a spoofed staff message should still be sent into a customer-visible Trip Planner chat',
      })}
      secondaryActionText={intl.formatMessage({
        id: 'wip8oZenvKtgFnXtBwsk',
        defaultMessage: 'Cancel',
        description: 'Secondary action button cancelling a spoofed staff message before it reaches a customer-visible Trip Planner chat',
      })}
      onPrimaryActionClick={handleConfirm}
      onSecondaryActionClick={handleCancel}
      onClose={handleCancel}
      tabletHeight="auto"
    >
      <BodyText variant="medium">
        <FormattedMessage
          id="z1rLmWc1tlDDx-8dg3n7"
          defaultMessage="This chat was created by the customer, so they will see any message you send. Continue?"
          description="Body of the confirmation modal shown before a spoofed staff message is sent into a chat that was created by (and is visible to) the customer"
        />
      </BodyText>
    </Modal>
  )
}

export default ConfirmSpoofSendModal
